import React, { useEffect, useMemo, useRef, useState } from 'react';

export default function SuperuserFarmPicker({
  farms,
  value,
  onChange,
  t,
  variant = 'navbar',
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, []);

  const selectedId = value || '';
  const label = useMemo(() => {
    if (!selectedId) return t('theme.farmHomeToken');
    const f = farms.find((x) => String(x.id) === String(selectedId));
    return f?.name || t('theme.farmHomeToken');
  }, [farms, selectedId, t]);

  const rootClass =
    variant === 'corner'
      ? 'shefa-farm-dropdown shefa-farm-dropdown--corner d-none d-lg-block'
      : variant === 'dock'
        ? 'shefa-farm-dropdown shefa-farm-dropdown--dock w-100'
        : 'shefa-farm-dropdown shefa-farm-dropdown--inline shefa-farm-dropdown--in-nav w-100 mt-2 mt-lg-0';

  return (
    <div className={rootClass} ref={ref}>
      <button
        type="button"
        className="btn shefa-farm-dropdown__toggle dropdown-toggle w-100 text-start d-flex align-items-center gap-2"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label={t('theme.farmMenu')}
      >
        <i className="fas fa-tractor flex-shrink-0" aria-hidden="true" />
        <span className="text-truncate flex-grow-1">{label}</span>
      </button>
      {open ? (
        <ul className="dropdown-menu show shefa-farm-dropdown__menu py-1 shadow" role="listbox">
          <li>
            <button
              type="button"
              className={`dropdown-item d-flex align-items-center gap-2 ${!selectedId ? 'active' : ''}`}
              onClick={() => {
                onChange('');
                setOpen(false);
              }}
            >
              {t('theme.farmHomeToken')}
            </button>
          </li>
          {farms.map((f) => (
            <li key={String(f.id)}>
              <button
                type="button"
                className={`dropdown-item text-truncate ${String(selectedId) === String(f.id) ? 'active' : ''}`}
                onClick={() => {
                  onChange(String(f.id));
                  setOpen(false);
                }}
              >
                {f.name}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
